import getColorPalette from './color-palette';
import getColorPaletteTemplate from './color-palette-template';
import getColorPalettes from './color-palettes';
import getFontPair from './font-pair';
import getFontPairTemplate from './font-pair-template';
import getFontPairs from './font-pairs';
import getCustomColorPalette from './custom-color-palette';
import getCustomColorPalettes from './custom-color-palettes';
import getColorPaletteConfig from './color-palette-config';
import getCustomColorSchemeTemplate from './custom-color-scheme-template';
import getCustomTextColors from './custom-text-colors';
import getCustomFontPairs from './custom-font-pairs';
import getColorPaletteConfigAssetUrl from './color-palette-config-asset-url';
import getColorPaletteVersion from './color-palette-version';
import getCurrentColorPaletteVersion from './current-color-palette-version';
import getButtonPresets from './button-presets';
import getButtonPreset from './button-preset';
import getButtonPresetTemplate from './button-preset-template';
import getButtonPresetPreviewTemplate from './button-preset-preview-template';
import getThemes from './themes';
import getTheme from './theme';
import getCurrentTheme from './current-theme';
import getCustomColors from './custom-colors';
import getCustomGradients from './custom-gradients';
import getDefaultColorPaletteId from './default-color-palette-id';
import getButtonPresetVersion from './button-preset-version';
import getCurrentButtonPresetVersion from './current-button-preset-version';
import getDefaultButtonPresetId from './default-button-preset-id';
import getTextDecorations from './text-decorations';

export default {
  getColorPalette,
  getColorPaletteTemplate,
  getColorPalettes,
  getFontPair,
  getFontPairTemplate,
  getFontPairs,
  getCustomColorPalettes,
  getCustomColorPalette,
  getColorPaletteConfig,
  getCustomColorSchemeTemplate,
  getCustomTextColors,
  getCustomFontPairs,
  getColorPaletteConfigAssetUrl,
  getColorPaletteVersion,
  getCurrentColorPaletteVersion,
  getButtonPresets,
  getButtonPreset,
  getButtonPresetTemplate,
  getButtonPresetPreviewTemplate,
  getThemes,
  getTheme,
  getCurrentTheme,
  getCustomColors,
  getCustomGradients,
  getDefaultColorPaletteId,
  getButtonPresetVersion,
  getCurrentButtonPresetVersion,
  getDefaultButtonPresetId,
  getTextDecorations,
};
